import React from 'react'

import { Actions } from '@frame/lib/actions'
import { Api } from '@frame/lib/api/types'
import { Events } from '@frame/lib/events'

type RootContext = {
  api: Api
  events: Events
  actions: Actions
}

const RootContext = React.createContext<RootContext>({} as RootContext)

export const RootContextProvider = RootContext.Provider

export function useRootContext(): RootContext {
  return React.useContext(RootContext)
}
